import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import {
  DATE_TIME_PICKER_FORMAT,
  DATE_PICKER_MAX_CALENDAR_DATE,
  DATE_PICKER_MIN_CALENDAR_DATE,
} from "../datePickerFormats";
import { DatePickerLocalizationProvider } from "../useDatePickerLocalization";

export default function CustomDateTimePicker(props: any) {
  const {
    format = DATE_TIME_PICKER_FORMAT,
    slotProps,
    minDate,
    maxDate,
    minDateTime,
    maxDateTime,
    ...restProps
  } = props;

  return (
    <DatePickerLocalizationProvider>
      <DateTimePicker
        {...restProps}
        minDate={minDate !== undefined ? minDate : DATE_PICKER_MIN_CALENDAR_DATE}
        maxDate={maxDate !== undefined ? maxDate : DATE_PICKER_MAX_CALENDAR_DATE}
        minDateTime={minDateTime}
        maxDateTime={maxDateTime}
        format={format}
        slotProps={{
          ...slotProps,
          actionBar: {
            actions: ["today", "clear"],
            ...slotProps?.actionBar,
          },
        }}
      />
    </DatePickerLocalizationProvider>
  );
}
